export const getInquiryFlowStartUrl = (store) => store.config.inquiryFlowStartUrl;
